/**
 * Single source for /brand page copy and matching FAQPage JSON-LD (keep in sync).
 */

export const BRAND_CANONICAL_LEAD =
  'Elodie Carstensen is a Berlin-based demi-couture fashion label and studio founded and led by designer Elodie Carstensen. The official monogram of the brand is a geometric crown mark (the crown logo / crown monogram) used on garment neck labels, packaging, and communications.';

export const BRAND_ALTERNATE_NAMES = [
  'Elodie Carstensen label',
  'Elodie Carstensen demi-couture',
  'Elodie Carstensen fashion',
];

export const BRAND_FAQ_ITEMS = [
  {
    id: 'crown-meaning',
    heading: 'What does the crown / monogram of Elodie Carstensen mean?',
    answer:
      'The crown mark is the official Elodie Carstensen monogram. It is the brand’s primary symbol and appears on authentic garments, labels, and official brand assets.',
    schemaQuestion: 'What does the crown monogram mean for Elodie Carstensen?',
  },
  {
    id: 'authentic-label',
    heading: 'How do you recognize an original Elodie Carstensen label?',
    answer:
      'Look for the Elodie Carstensen name together with the crown monogram on the neck label or garment tag, with consistent typography. Compare with the official downloads on this page if you are unsure.',
    schemaQuestion: 'How do you recognize an original Elodie Carstensen neck label?',
  },
  {
    id: 'founder',
    heading: 'Who founded Elodie Carstensen?',
    answer:
      'The fashion label Elodie Carstensen is founded and led by designer Elodie Carstensen. The studio is based in Berlin, Germany (Kadiner Str. 20A, 10243 Berlin).',
    schemaQuestion: 'Who founded Elodie Carstensen?',
  },
  {
    id: 'category',
    heading: 'What kind of fashion is Elodie Carstensen?',
    answer:
      'Elodie Carstensen is a contemporary demi-couture label, predominantly made-to-order, at the intersection of neo-romanticism and futurism. Work often extends into performance, installation, and collaboration—not only seasonal product.',
    schemaQuestion: 'Is Elodie Carstensen demi-couture or contemporary fashion?',
  },
  {
    id: 'logo-search',
    heading: 'What brand is this crown logo?',
    answer:
      'A geometric crown monogram used with the name Elodie Carstensen on labels and communications refers to the Berlin-based fashion label Elodie Carstensen. Official assets are published on elodiecarstensen.com/brand.',
    schemaQuestion: 'What brand uses the Elodie Carstensen crown logo?',
  },
];

/** FAQPage mainEntity entries for JSON-LD */
export const getBrandFaqSchemaEntities = () =>
  BRAND_FAQ_ITEMS.map(({ schemaQuestion, answer }) => ({
    '@type': 'Question',
    name: schemaQuestion,
    acceptedAnswer: {
      '@type': 'Answer',
      text: answer,
    },
  }));
